import React from "react"
//import I18n from "i18n-js/index.js.erb"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"

class ProcessPaymentsPreview extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      loading: false,
    };
    this.runPayments = this.runPayments.bind(this);
  };

  render(){
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.runPayments,
      },
    ]

    return(
      <div>
        <ModalButtons loading={this.state.loading} buttons={buttons} />
        <LoadingSpinner show={this.state.loading} />
        <div><label>{I18n.t('rooms')}: <span>{this.props.task_details && this.props.task_details.segments_for_payment ? this.props.task_details.segments_for_payment.length : 0}</span></label></div>
        <div><label>{I18n.t('deposits')}: <span>{this.props.task_details && this.props.task_details.deposit_count ? this.props.task_details.deposit_count : 0}</span></label></div>
        <div><label>{I18n.t('balances')}: <span>{this.props.task_details && this.props.task_details.balance_count ? this.props.task_details.balance_count : 0}</span></label></div>
      </div>
    );
  };

  runPayments(){
    this.setState({loading:true});
    $.ajax({
      type: 'POST',
      url: '/admin/process_payments_tasks_run',
      data: {
        segments: this.props.task_details.segments_for_payment
      }
    }).done((response) => {
      this.setState({loading:false});
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('payments_processed'))
      };
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      };
    });
  };
};

export default ProcessPaymentsPreview